import React, { Component } from 'react'
import '../scss/about.scss'
export default class About extends Component {
  render() {
    return (
      <>
        <section className='about' >
            <div className='container'>
                <h1>Hii, I'm Ajay. Nice to meet you.</h1>
                < h2 > Since beginning my journey as a competitive coder one year ago, I've gained a lot of expirience in practical problem solving. Then I dived into 
                web developing as it make me curious to work on interface with which I can help other with my problem solving ability. I'm quietly confident, naturally curious, and perpetually working on improving my problem solving ability at a time. </h2>
            </div>
        </section>
      </>
    )
  }
}
